import { JsBridge, SendPreferenceCRMData, encodeData } from './js-bridge';
export class JsBridgeAndriod extends JsBridge {
    appOpenRacingLiveStream(): void {
        AosDiscoverJsBridge?.appOpenRacingLiveStream();
    }
    appGetLocalStorageDataRequest(): void {
        // console.log('call appGetLocalStorageDataRequest------AOS');
        AosDiscoverJsBridge?.appGetLocalStorageDataRequest();
    }
    appGetLocalStorageDataRequestAsync(): void {
        console.log('call appGetLocalStorageDataRequestAsync------AOS');
    }
    appShareUrl(url: string): void {
        AosDiscoverJsBridge?.appShareUrl(url);
    }
    // appDirectTo(page: 'CouponList' | 'P-CardPage'): void {
    //     AosDiscoverJsBridge?.appDirectTo(page);
    // }
    appOpenExternalBrowser(url: string): void {
        AosDiscoverJsBridge?.appOpenExternalBrowser(url);
    }
    appSetUiVisibility(ui: 'btnBack' | 'btnCalendar' | 'btnSkip', visable: boolean): void {
        AosDiscoverJsBridge?.appSetUiVisibility(ui, visable);
    }
    appSaveDiscoverPreference(data: SendPreferenceCRMData): void {
        const jsonStringBase64 = encodeData(data);
        AosDiscoverJsBridge?.appSaveDiscoverPreference(jsonStringBase64);
    }
    appCloseNativePIP(): void {
        AosDiscoverJsBridge?.closeNativePIP();
    }
    appOpenNativePlayer(url: string): void {
        console.log('appOpenNativePlayer', url);
    }
    appOpenMsLiveStream(): void {
        console.log('appOpenMsLiveStream');
    }
    addCalendarEvent(
        title: string,
        description: string,
        eventUUID: string,
        startTime: number,
        endTime: number
    ): void | any {
        console.log('appOpenMsLiveStream-----AOS');
    }
    appOnLeavePreferencePage(): void {
        console.log('appOnLeavePreferencePage-----------AOS');
    }
    setAllBettingStrategies(value: boolean): void {
        console.log('setAllBettingStrategies-----AOS');
    }
}
